// pages/LuxotticaRegisterPage.jsx (or any page file)
import React from 'react';
import RecoveryPage from '@/components/RecoveryPage';
import config from '@/config';
import { buildPath } from '@/utils/routeBuilder';

const IconicRecoveryPage = () => {
  return (
    <RecoveryPage
      projectId="iconic"
      projectName="Iconic"
      loginPath={buildPath('/iconic/login')}
      apiUrl={config.AUTH_API_ADDRESS}
      brandColor="blue"
    />
  );
};

export default IconicRecoveryPage;